export const OPACITY = 33

export const OPACITY_ARR = ['44', '66', '88', 'ff']

export const MAX_WAVES = 4

export const HEIGHT_ARR = [400, 500, 600, 700]
